import { Component, Input } from '@angular/core';
import { Post, } from "../../../app/app.interfaces";


@Component({
  selector: 'post-card',
  templateUrl: 'post-card.html'
})

export class PostCard {
  @Input() post: Post;
}





// WEBPACK FOOTER //
// ./src/partials/post/post-card/post-card.ts